// test897
(897 && 0);
